
<template>
  <div class="content"> 
  <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <v-data-table
      :headers="headers"
      :items="topic"
      sort-by="modulename"
      class="table-user mt-4 rounded-lg mx-6"
      >
        <template v-slot:top>
          <v-toolbar flat class="rounded-lg">
            <v-toolbar-title><v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field> </v-toolbar-title> 
            <v-spacer></v-spacer>
            <v-flex lg3>
              
            </v-flex> 

            <!-- v dialog  -->
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  outlined
                  rounded
                  small
                  color="primary"
                  dark
                  class="mb-2" 
                  v-bind="attrs"
                  v-on="on"
                  >
                  Add new topic
                  <v-icon class="ml-2">mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                  <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
                  <v-card-text class="overflow-card" style="height: 400px">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field outlined dense v-model="editedItem.topicname" label="Topic Name">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-select label="Status" dense outlined 
                          :items="keywordstatusselectw" 
                          item-text="namew" 
                          item-value="valuew" 
                          v-model="topicstatusw" 
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                        <v-row class="ma-0 pa-0">
                          <v-flex lg6>
                            <v-text-field outlined dense v-model="editedItem.topicname" label="Keywords"></v-text-field>
                          </v-flex>
                          <v-flex lg6>
                            <v-btn class="mx-2 elevation-0" @click="add" dark outlined icon color="#0471A5"><v-icon>mdi-plus</v-icon></v-btn>
                            <v-btn class="elevation-0" outlined color="#0471A5" icon><v-icon>mdi-minus</v-icon></v-btn>
                          </v-flex>
                        </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-select label="Seen Privilege" dense outlined :items="privilege" v-model="editedItem.topicstatus" value="Admin"></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-divider></v-divider>
                  <v-card-actions class="py-3">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                      Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="save">
                      Save 3
                    </v-btn>
                  </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- end v dialog insert  -->
            <v-dialog v-model="dialogDelete" width="330px"> 
              <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                <v-avatar class="color-avatar3 my-4" size="62">
                  <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                </v-avatar>
                <div class="text-center text-h6 align-center justify-center font-weight-medium">
                  Confirm Deletion
                </div> 
                <v-card-text class="align-center justify-center mt-2">
                  Are you sure you want to permanently delete this item?
                </v-card-text>

                <v-divider class="mt-4" style=""></v-divider>

                <v-card-actions class="align-center justify-center">
                  <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                    OK
                  </v-btn>
                  <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- end dilog delete  -->
          </v-toolbar>
        </template>

        <template v-slot:[`item.infotopic`]="{ item }">
          <v-dialog v-model="dialogtopic" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-1" icon v-bind="attrs" v-on="on" @click="(item)">
                <v-icon small>mdi-information-outline</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h6">Topic</span>
              </v-card-title>
              <v-card-text>
                <v-list-item>
                  <v-list-item-avatar color="#EDF4FB">
                    <v-icon color="#439EDF" dark>
                      mdi-account-outline
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Created By</v-list-item-title>
                    <v-list-item-subtitle>Azra Saskia Putri Delia</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-avatar color="#EDF4FB">
                    <v-icon color="#439EDF" dark>
                      mdi-clock-outline
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Created Date</v-list-item-title>
                    <v-list-item-subtitle>2018-09-20 15:49:22</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-avatar color="#EDF4FB">
                    <v-icon color="#439EDF" dark>
                      mdi-account-reactivate-outline
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Update By</v-list-item-title>
                    <v-list-item-subtitle>Azra Saskia</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-avatar color="#EDF4FB">
                    <v-icon color="#439EDF" dark>
                      mdi-history
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Update Date</v-list-item-title>
                    <v-list-item-subtitle>2022-10-03 15:49:22</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>
              </v-card-text>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
<!-- edit topic status  -->
        <template v-slot:[`item.editstatus`]="{ item }">
          <v-dialog v-model="dialogstatus" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-1" icon v-bind="attrs" v-on="on" @click="editItemTopic(item.SEQ_ID)">
                <v-icon small>mdi-pencil</v-icon> 
              </v-btn>
            </template>

            <v-card>
              <v-card-title><span class="text-h6">Edit Topic Status</span></v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                    <v-select label="Keyword Status" dense outlined 
                    :items="keywordstatusselect" 
                    item-text="name" 
                    item-value="value" 
                    v-model="topicstatus" 
                    ></v-select>
                  </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeTopicDialog">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="saveedittopic">
                    Save
                  </v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
          
        </template>
<!-- end edit topic status  -->

        <template v-slot:[`item.infokeyword`]="{ item }">
          <v-dialog v-model="dialogkeyword" max-width="500px">
             <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-1" icon v-bind="attrs" v-on="on" @click="(item)">
                  <v-icon small>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title><span class="text-h6">Keyword</span></v-card-title>
                <v-card-text>
                <v-list-item>
                  <v-list-item-avatar color="#EDF4FB">
                    <v-icon color="#439EDF" dark>
                      mdi-account-outline
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Created By</v-list-item-title>
                    <v-list-item-subtitle>Azra Saskia Putri Delia</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-avatar color="#EDF4FB">
                    <v-icon color="#439EDF" dark>
                      mdi-clock-outline
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Created Date</v-list-item-title>
                    <v-list-item-subtitle>2018-09-20 15:49:22</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-avatar color="#EDF4FB">
                    <v-icon color="#439EDF" dark>
                      mdi-account-reactivate-outline
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Update By</v-list-item-title>
                    <v-list-item-subtitle>Azra Saskia</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-avatar color="#EDF4FB">
                    <v-icon color="#439EDF" dark>
                      mdi-history
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Update Date</v-list-item-title>
                    <v-list-item-subtitle>2022-10-03 15:49:22</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>
              </v-card-text>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--edit keyword-->
          <v-dialog v-model="dialogeditkeyword" max-width="500px" max-height="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-1" icon v-bind="attrs" v-on="on" @click="(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title><span class="text-h6">Edit Keyword</span></v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-row class="ma-0 pa-0 ml-3 mt-2">
                    <v-flex lg6>
                      <v-text-field outlined dense v-model="editedItem.topicname" label="Keywords"></v-text-field>
                    </v-flex>
                    <v-flex lg6>
                      <v-btn class="mx-2 elevation-0" @click="add" dark outlined icon color="#0471A5"><v-icon>mdi-plus</v-icon></v-btn>
                      <v-btn class="elevation-0" outlined color="#0471A5" icon><v-icon>mdi-minus</v-icon></v-btn>
                    </v-flex>
                  </v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select label="Status" dense outlined :items="keywordstatusselect" v-model="editedItem.keywordstatus" value="Enabled"></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!--dialog delete-->
          <v-dialog v-model="dialogDelete" width="330px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-1" icon v-bind="attrs" v-on="on" @click="(item)">
                <v-icon small>mdi-trash-can</v-icon>
              </v-btn>
            </template>
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-delete my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure want to delete keyword?
              </v-card-text>

              <v-divider class="mt-4" style=""></v-divider>

              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-info" width="90px" dark @click="dialog = false">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="dialog = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!--end dialog delete-->
        </template>

        <template v-slot:[`item.editprivilege`]="{ item }">
          <v-dialog v-model="dialogprivilege" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-1" icon v-bind="attrs" v-on="on" @click="(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title><span class="text-h6">Edit Privilege</span></v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-select label="Privilege" dense outlined :items="privilege" v-model="editedItem.topicstatus" value="Enabled"></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="save">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </div>
</template>


<script>
import axios from "axios"
  export default {
    data: () => ({
    itemskeyword: ['Banjir', 'Kebakaran Hutan', 'Tsunami', 'Politik', 'Pemerintah'],
    search: '',
    dialog: false,
    dialogstatus: false,
    dialogeditkeyword: false,
    dialogDelete: false,
    dialogtopic: false,
    dialogkeyword: false,
    dialogprivilege: false,
    // keywordstatusselect: ['Enabled', 'Disabled'],
    topicstatus :1,
    keywordstatusselect: [//choice select
            {value: 1, name: "Enabled" },
            {value: 0, name: "Disabled" }
    ],
    privilege: ['Admin', 'Staff'],
    rolestatus: ['Enabled', 'Disabled'],
    keyword: ['Banjir', 'Tanah Longsor', 'Politik'],
    page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Keyword Manager',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Topic & Keyword',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      headers: [
        { text: 'Topic Name', value: 'GROUP_NAME' },
        { text: '', value: 'infotopic', sortable: false },
        { text: 'Status', value: 'GROUP_STATUS_TEXT' },
        { text: '', value: 'editstatus', sortable: false },
        { text: 'Keyword', value: 'KEYWORD_ARR' },
        { text: '', value: 'infokeyword', sortable: false },
        { text: 'Seen Privilege', value: 'KEYWORD_PRIVILAGE_ARR' },
        { text: '', value: 'editprivilege', sortable: false },
      ],
      
      topic: [],
      table: [],
      id_topic: '',
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Tambah Kata Kunci' : 'Edit Kata Kunci'
      },
    },
    watch: {
      dialogstatus(val){
        val || this.closeTopicDialog()
      },
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        axios.get("topic-keyword",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            this.topic =  response.data;
            setTimeout(() =>{
              this.loading = false
            // end loading 
            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                  case 404:
                        alert('Maaf Anda Belum Login')
                        this.$router.push('/');
                        // jika belum login local storage wajib dihapus
                        localStorage.removeItem('username');
                        localStorage.removeItem('token_app');
                        localStorage.removeItem('email');
                      break;
                  case 403:
                    
                        alert('Maaf Anda Menyalahi Wewenang Menggunakan Sistem Ini')
                        this.$router.push('/');
                        // jika belum login local storage wajib dihapus
                        localStorage.removeItem('username');
                        localStorage.removeItem('token_app');
                        localStorage.removeItem('email');
                      break;
                  default:
                      console.log('some other error');  // end up here all the time
                      break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      
      editItemTopic (item){
        // alert(item);
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/getid-topic-keyword",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = response.data;
            this.topicstatus =dat.GROUP_STATUS; 
            this.dialogstatus =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },
      saveedittopic(){
        axios.put("/update-topic-keyword", 
            {
              seq_id_topic:this.id_topic,
              status_topic:this.topicstatus
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            
              this.initialize()
              this.$router.push('/topickeyword');
              // alert('okk');      
              console.log(response.data);  
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          alert('Maaf Anda Belum Login')
                          // this.$router.push('/');
                          // // jika belum login local storage wajib dihapus
                          // localStorage.removeItem('username');
                          // localStorage.removeItem('token_app');
                          // localStorage.removeItem('email');
                        break;
                    case 403:
                          alert('Maaf Anda Menyalahi Wewenang Menggunakan Sistem Ini')
                          // this.$router.push('/');
                          // // jika belum login local storage wajib dihapus
                          // localStorage.removeItem('username');
                          // localStorage.removeItem('token_app');
                          // localStorage.removeItem('email');
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
          this.closeTopicDialog();
      },
      closeTopicDialog(){
        this.dialogstatus = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },










      

      editItem (item) {
        this.editedIndex = this.topic.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.topic.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.topic.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.topic[this.editedIndex], this.editedItem)
        } 
        else {
          this.topic.push(this.editedItem)
        } this.close()
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.tabsitem{
  background-color:#F7F6F4;
}
.btn-info{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-delete
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.overflow-card{
  overflow: scroll;
}
</style>